export type DirectConversionResolution = 'pending' | 'control' | 'treatment'

export function isDirectConversionPreview(abParam: string | null): boolean {
    return abParam === 'direct'
}

export function resolveDirectConversion(input: {
    abParam: string | null
    variant: 'control' | 'treatment'
    isReady: boolean
}): DirectConversionResolution {
    if (isDirectConversionPreview(input.abParam)) return 'treatment'
    if (!input.isReady) return 'pending'
    return input.variant === 'treatment' ? 'treatment' : 'control'
}
